export default __webpack_public_path__ + "static/media/about-us-02.afe6e007.jpg";